import { Box } from "grommet";

export const BoxWindow = ({children, topPadding = false, bottomPadding = true, ...props}) => {
    return (
        <Box {...props} pad={{left: 'medium', right: 'medium', bottom: bottomPadding ? 'medium' : 'none', top: topPadding ? 'large' : 'none'}} fill="vertical">
            {children}
        </Box>
    )
};